// Module
var code = "<a href=\"javascript:;\" class=\"text-sm sps-btn sps-btn-outline btn-color-follow-up follow-up-button\"> <i class=\"fa fa-arrow-up\"></i><span><!-- ko text: _labels.FOLLOW_UP --><!-- /ko --></span> </a>";
// Exports
export default code;